module.exports = __webpack_public_path__ + "050bd42fa1693641ac75b76d120bd009.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg43.jpeg
// module id = 54
// module chunks = 0